import React, { Component } from 'react';
import { bool, func, object, shape, string } from 'prop-types';
import { Field } from 'react-final-form';
import { ValidationError } from '../../components';
import CheckboxGroup from '../CustomGroupCheckbox/CustomGroupCheckbox';

class FieldCheckboxGroupCustomComponent extends Component {
  render() {
    /* eslint-disable no-unused-vars */
    const {
      rootClassName,
      className,
      inputRootClass,
      customErrorText,
      id,
      name,
      input,
      meta,
      onUnmount,
      isUncontrolled,
      inputRef,
      options,
      valuesOfInput,
      ...rest
    } = this.props;
    /* eslint-enable no-unused-vars */

    if (!id) {
      throw new Error('id required when a label is given');
    }

    const { invalid, touched, error } = meta;

    const errorText = customErrorText || error;

    // Error message and input error styles are only shown if the
    // field has been touched and the validation has failed.
    const hasError = !!customErrorText || !!(touched && invalid && error);

    const fieldMeta = { touched: hasError, error: errorText };

    return (
      <>
        <CheckboxGroup name={name} value={input.value} onChange={input.onChange}>
          {Checkbox => (
            <div className="tags">
              {options.map(v => (
                <label
                  className={` ${(input.value || []).includes(v.key) ? 'selected' : ''}`}
                  data-list-item
                >
                  <div style={{ display: 'none' }}>
                    <Checkbox value={v.key} />
                  </div>
                  {v.label}
                </label>
              ))}
            </div>
          )}
        </CheckboxGroup>
        <ValidationError fieldMeta={fieldMeta} />
      </>
    );
  }
}

FieldCheckboxGroupCustomComponent.defaultProps = {
  rootClassName: null,
  className: null,
  inputRootClass: null,
  onUnmount: null,
  customErrorText: null,
  id: null,
  label: null,
  isUncontrolled: false,
  inputRef: null,
};

FieldCheckboxGroupCustomComponent.propTypes = {
  rootClassName: string,
  className: string,
  inputRootClass: string,

  onUnmount: func,

  // Error message that can be manually passed to input field,
  // overrides default validation message
  customErrorText: string,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string,
  label: string,

  // Uncontrolled input uses defaultValue prop, but doesn't pass value from form to the field.
  // https://reactjs.org/docs/uncontrolled-components.html#default-values
  isUncontrolled: bool,
  // a ref object passed for input element.
  inputRef: object,

  // Generated by final-form's Field component
  input: shape({
    onChange: func.isRequired,
    // Either 'textarea' or something that is passed to the input element
    type: string.isRequired,
  }).isRequired,
  meta: object.isRequired,
};

class FieldCheckboxGroupCustom extends Component {
  componentWillUnmount() {
    // Unmounting happens too late if it is done inside Field component
    // (Then Form has already registered its (new) fields and
    // changing the value without corresponding field is prohibited in Final Form
    if (this.props.onUnmount) {
      this.props.onUnmount();
    }
  }

  render() {
    return <Field component={FieldCheckboxGroupCustomComponent} {...this.props} />;
  }
}

export default FieldCheckboxGroupCustom;
